var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8335 62.5H54.1668V70.8333H45.8335V62.5ZM45.8335 29.1667H54.1668V54.1667H45.8335V29.1667ZM49.9585 8.33333C26.9585 8.33333 8.3335 27 8.3335 50C8.3335 73 26.9585 91.6667 49.9585 91.6667C73.0002 91.6667 91.6668 73 91.6668 50C91.6668 27 73.0002 8.33333 49.9585 8.33333ZM50.0002 83.3333C31.5835 83.3333 16.6668 68.4167 16.6668 50C16.6668 31.5833 31.5835 16.6667 50.0002 16.6667C68.4168 16.6667 83.3335 31.5833 83.3335 50C83.3335 68.4167 68.4168 83.3333 50.0002 83.3333Z",
    fill: "#CC3300"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.cdd8674c0dd53b4b5549ed464b804a88.svg";
export { ForwardRef as ReactComponent };